import React, { useState } from 'react';
import { InputNumber, Button, Space, Input } from 'antd';
import { SyncOutlined, UploadOutlined } from '@ant-design/icons';
import { handleVariantImageUpload } from '../../util/variantUtils';
import Notify from '../../util/Notify';

const BulkOperations = ({ onApply }) => {
    const [defaultMrp, setDefaultMrp] = useState(null);
    const [defaultPrice, setDefaultPrice] = useState(null);
    const [defaultStock, setDefaultStock] = useState(null);
    const [defaultImage, setDefaultImage] = useState('');
    const [uploading, setUploading] = useState(false);

    const handleApply = () => {
        const updates = {};
        if (defaultMrp !== null) updates.mrp = defaultMrp;
        if (defaultPrice !== null) updates.price = defaultPrice;
        if (defaultStock !== null) updates.stock = defaultStock;
        if (defaultImage) updates.imageUrl = defaultImage;

        if (Object.keys(updates).length > 0) {
            onApply(updates);
            Notify.success('Bulk settings applied to all variants');
        } else {
            Notify.warning('No values entered to apply');
        }
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        try {
            setUploading(true);
            const url = await handleVariantImageUpload(file);
            setDefaultImage(url);
        } catch (err) {
            Notify.error("Image upload failed");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div style={{ padding: '12px', background: '#f1f5f9', borderRadius: '12px', marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'flex-end' }}>
            <div style={{ flex: 1, minWidth: '120px' }}>
                <div style={{ fontSize: '10px', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', marginBottom: '4px' }}>Default MRP</div>
                <InputNumber placeholder="₹" value={defaultMrp} onChange={setDefaultMrp} style={{ width: '100%', borderRadius: '6px' }} size="small" />
            </div>
            <div style={{ flex: 1, minWidth: '120px' }}>
                <div style={{ fontSize: '10px', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', marginBottom: '4px' }}>Default Selling</div>
                <InputNumber placeholder="₹" value={defaultPrice} onChange={setDefaultPrice} style={{ width: '100%', borderRadius: '6px' }} size="small" />
            </div>
            <div style={{ flex: 1, minWidth: '120px' }}>
                <div style={{ fontSize: '10px', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', marginBottom: '4px' }}>Default Stock</div>
                <InputNumber placeholder="Qty" value={defaultStock} onChange={setDefaultStock} style={{ width: '100%', borderRadius: '6px' }} size="small" />
            </div>
            <div style={{ flex: 2, minWidth: '200px' }}>
                <div style={{ fontSize: '10px', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', marginBottom: '4px' }}>Default Image</div>
                <Space.Compact style={{ width: '100%' }}>
                    <Input value={defaultImage} onChange={e => setDefaultImage(e.target.value)} placeholder="Image URL" size="small" />
                    <Button icon={<UploadOutlined />} size="small" loading={uploading} onClick={() => document.getElementById('bulk-img-upload').click()} />
                    <input type="file" id="bulk-img-upload" hidden onChange={handleImageUpload} accept="image/*" />
                </Space.Compact>
            </div>
            <div>
                <Button type="primary" size="small" icon={<SyncOutlined />} onClick={handleApply} style={{ borderRadius: '6px', fontWeight: 600 }}>
                    Apply To All
                </Button>
            </div>
        </div>
    );
};

export default React.memo(BulkOperations);
